import { render, staticRenderFns } from "./combination.vue?vue&type=template&id=bedaf826"
import script from "./combination.vue?vue&type=script&lang=js"
export * from "./combination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports